import React, { useEffect, useRef } from 'react';
import './InfoBoxModal.css';
import { SERVER_URL } from '../../shared/apiConfig';

const InfoBoxModal = ({ isOpen, onClose, ingredient, addSelectedIngredient }) => {
    const modalRef = useRef(null);

    useEffect(() => {
        // Function to handle clicks outside the modal
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onClose();
            }
        };

        // Add event listener when modal is open
        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        // Cleanup function to remove event listener
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div className="modal-drommekoppen">
            <div className="modal-content-drommekoppen" ref={modalRef}>
                <span className="close-button" onClick={onClose}>&times;</span>
                <h2>{ingredient.name}</h2>
                <img
                    src={`${SERVER_URL}${ingredient.imagePath}`}
                    alt={ingredient.name}
                    className="ingredient-image-modal"
                    onError={(e) => (e.target.src = '/images/default.png')} // Updated fallback image path
                />
                <p>{ingredient.description || "Ingen beskrivelse tilgjengelig."}</p>
                <button
                    className="add-button"
                    onClick={() => {
                        if (ingredient) {
                            addSelectedIngredient(ingredient);
                            onClose();
                        } else {
                            console.warn("No ingredient provided to add.");
                        }
                    }}
                >
                    Add
                </button>
            </div>
        </div>
    );
};

export default InfoBoxModal;